import {CheckboxControl} from '../../../shared/classes/controls';

import {PermissionGroupedSubControl} from './permission-grouped-sub-control';

export class PermissionGroupedControl {
    private readonly subControls: PermissionGroupedSubControl[];

    private formIndex: number;
    private mainFormIndex: number;
    public id: string;
    public name: string;
    public application: string;
    public applicationIndex: number;
    public showApplicationTitle: boolean;
    public isDummyGroup: boolean;
    public sortIndex: number;
    public mainControl: CheckboxControl;

    constructor(
        id: string,
        name: string,
        application: string,
        applicationIndex: number,
        sortIndex: number,
        mainControl?: CheckboxControl,
        subControls?: PermissionGroupedSubControl[],
        showApplicationTitle?: boolean,
        isDummyGroup?: boolean
    ) {
        this.id = id;
        this.name = name;
        this.application = application;
        this.applicationIndex = applicationIndex;
        this.showApplicationTitle = showApplicationTitle;
        this.isDummyGroup = isDummyGroup;
        this.sortIndex = sortIndex;
        this.mainControl = !mainControl ? null : mainControl;
        this.subControls = !subControls ? [] : subControls;

        this.formIndex = null;
        this.mainFormIndex = null;
    }

    addSubControl(control: PermissionGroupedSubControl): void {
        this.subControls.push(control);
    }

    getSubControls(): PermissionGroupedSubControl[] {
        return this.subControls;
    }

    toggleSubControls(status: boolean): void {
        if (this.isDummyGroup)
        {
            this.subControls.map((control: PermissionGroupedSubControl) => {
                control.control.setChecked(status, true);
            });
        }
        else {
            this.subControls.map((control: PermissionGroupedSubControl) => {
                if (status)
                {
                    control.control.setChecked(false, true);
                }
                control.control.disabled = status;
            });
        }
    }

    isCheckedAllSubControls(): boolean {
        return this.subControls
            .map((control: PermissionGroupedSubControl) => {
                return control.control.getChecked();
            })
            .indexOf(false) < 0;
    }

    getSubControlsCols(): number[] {
        const cols = this.subControls.map((subItem: PermissionGroupedSubControl) => {
            return subItem.position.col;
        });

        return cols.filter((col: number, index: number) => {
            return cols.indexOf(col) === index;
        });
    }

    getSubControlsRowsByCol(col: number): number[] {
        return this.subControls.filter((subItem: PermissionGroupedSubControl) => {
            return subItem.position.col === col;
        }).map((subItem: PermissionGroupedSubControl) => {
            return subItem.position.row;
        });
    }

    getSubControlByPosition(col: number, row: number): PermissionGroupedSubControl {
        const filteredSubControls = this.subControls.filter((subItem: PermissionGroupedSubControl) => {
            return (subItem.position.col === col) && (subItem.position.row === row);
        });

        if (filteredSubControls.length > 0) {
            return filteredSubControls[0];
        }

        return null;
    }

    setFormIndex(index: number): void {
        this.formIndex = index;
    }

    getFormIndex(): string {
        return this.formIndex.toString();
    }

    setMainFormIndex(index: number) {
        this.mainFormIndex = index;
    }

    getMainFormIndex(): string {
        return this.mainFormIndex.toString();
    }
}
